'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _styles = require('./styles.scss');

var _styles2 = _interopRequireDefault(_styles);

var _trainings = require('ifeis-isomorphic/lib/redux/actions/trainings');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AdminTrainingsController = function () {
  function AdminTrainingsController($ngRedux, fRouterHistoryService, $mdDialog, fAlert, msgService, fPrompt) {
    var _this = this;

    _classCallCheck(this, AdminTrainingsController);

    this.edit = function ($event) {
      var training = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      _this._.$mdDialog.show({
        event: $event,
        controller: function controller($scope) {
          $scope.cancel = function () {
            _this._.$mdDialog.cancel();
          };

          $scope.training = _extends({}, training);

          $scope.answer = function (training) {
            _this._.$mdDialog.hide(training);
          };

          $scope.toggleRole = function (role) {
            var training = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            training = !training.roles ? _extends({}, training, { roles: [] }) : training;
            var foundRoleIndex = training.roles.findIndex(function (r) {
              return r === role;
            });
            foundRoleIndex > -1 ? training.roles.splice(foundRoleIndex, 1) : training.roles.push(role);
            return training;
          };
        },
        template: ['<md-dialog ng-class="class">', '  <form novalidate name="form">', '  <md-content>', '    <md-subheader class="md-sticky-no-effect">{{ training.id ? "Modify" : "Add New"}} Training</md-subheader>', '    <div style="padding: 5px"><md-input-container class="prompt-input-container" style="width: 90%">', '      <label>Training Name</label>', '      <input ng-if="!training.id" type="text" ng-model="training.name" class="dialog-close" required />', '      <input ng-if="training.id" type="text" ng-model="training.name" class="dialog-close" disabled />', '    </md-input-container></div>', '    <div><md-input-container class="prompt-input-container" style="width: 90%">', '      <label>Training URL</label>', '      <input type="text" ng-model="training.url" class="dialog-close" required />', '    </md-input-container></div>', '   <div style="padding: 5px; margin: 18px 0" layout="row" layout-wrap>Roles</div>', '   <div  style="padding: 5px; margin: 18px 0" layout="row" layout-wrap >', '      <div flex="50">', '          <md-checkbox ng-checked="training.roles.includes(\'registration\') ?  1 : 0"\n' + '           ng-click="training = toggleRole( \'registration\', training )">Perform Registrations</md-checkbox>\n' + '        </div>\n' + '        ' + '        <div flex="50">\n' + '          <md-checkbox ng-checked="training.roles.includes(\'results\') ? 1 : 0" \n' + '                       ng-click="training = toggleRole( \'results\', training )">Manage Results</md-checkbox>\n' + '        </div>\n' + '        ' + '       <div flex="50">\n' + '          <md-checkbox ng-checked="training.roles.includes(\'stage\') ? 1 : 0"\n' + '                       ng-click="training = toggleRole( \'stage\', training )">Run Stages</md-checkbox>\n' + '        </div>\n' + '        ' + '        <div flex="50">\n' + '          <md-checkbox ng-checked="training.roles.includes(\'tabulations\') ? 1 : 0"\n' + '                       ng-click="training = toggleRole( \'tabulations\', training )">Control Tabulations</md-checkbox>\n' + '        </div>\n' + '      ' + '     </div>', '  </md-content>', '  <div class="md-actions" layout="row">', '    <md-button type="button" ng-click="cancel()" class="md-primary">Cancel</md-button>', '    <md-button type="submit" ng-disabled="form.$invalid" ng-click="answer( training )">Save</md-button>', '  </div>', '  </form>', '</md-dialog>'].join("\n")
      }).then(function (data) {
        if (!(data.url.startsWith('http://') || data.url.startsWith('https://') || data.url.startsWith('s3://'))) {
          var url = data.url;
          data.url = 'https://' + url;
        }
        _this._.$ngRedux.dispatch(data.id ? (0, _trainings.updateTrainingResource)(data) : (0, _trainings.createTrainingResource)(data)).then(function () {
          var response = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

          if (data.id || _this.trainings.some(function (t) {
            return t.name === response.payload.name;
          })) {
            _this.trainings = _this.trainings.map(function (t) {
              if (t.id === response.payload.id) {
                t = response.payload;
                return t;
              }
              return t;
            });
          } else {
            _this.trainings.push(response.payload);
          }

          return Promise.resolve();
        }).catch(function () {
          _this._.msgService.error('Could not add training: ' + data);
        });
      });
    };

    this.trainings = [];
    this._ = { $ngRedux: $ngRedux, $mdDialog: $mdDialog, fAlert: fAlert, msgService: msgService, fPrompt: fPrompt };
    this._.$ngRedux.dispatch((0, _trainings.getAllTrainingResources)()).then(function (response) {
      return (response.payload || []).forEach(function (r) {
        _this.trainings.push({
          name: r.trainings.name,
          url: r.trainings.url,
          id: r.trainings.id,
          roles: r.trainings.roles || []
        });
      });
    });
  }

  _createClass(AdminTrainingsController, [{
    key: 'remove',
    value: function remove($event, id) {
      var _this2 = this;

      this._.$ngRedux.dispatch((0, _trainings.deleteTrainingResource)(id)).then(function () {
        _this2.trainings = _this2.trainings.filter(function (t) {
          return t.id !== id;
        });
      });
    }
  }]);

  return AdminTrainingsController;
}();

exports.default = angular.module('ifeis.routes.admin.trainings', ['ui.router', 'ngMaterial']).config(function ($stateProvider) {
  $stateProvider.state('admin.trainings', {
    url: '/trainings',
    template: require('./tpl.html'),
    controller: AdminTrainingsController,
    controllerAs: 'adminTrainings',
    ncyBreadcrumb: {
      label: 'Trainings',
      parent: 'admin.dashboard'
    }
  });
});


//////////////////
// WEBPACK FOOTER
// ./routes/admin/trainings/index.js
// module id = 518
// module chunks = 0